import React from "react";

export const RuleCategorised = ({ size = "24" }: { size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.0001" cy="12" r="10" fill="#9254E5" fill-opacity="0.5" />
      <circle
        cx="12.0001"
        cy="12"
        r="10"
        fill="url(#paint0_linear_6844_3677)"
      />
      <g clip-path="url(#clip0_6844_3677)">
        <path
          d="M17.0802 11.1534V13.2698H16.2336V11.7519L14.7886 13.197C14.6311 13.3545 14.5405 13.5729 14.5405 13.7955V17.0793H13.694V13.7955C13.694 13.3498 13.8747 12.9134 14.1901 12.5985L15.6351 11.1534H14.1172V10.3069H16.2336C16.7005 10.3069 17.0802 10.6865 17.0802 11.1534ZM8.38307 11.1534H9.90095V10.3069H7.78455C7.31767 10.3069 6.93799 10.6865 6.93799 11.1534V13.2698H7.78455V11.7519L9.22963 13.197C9.38751 13.3545 9.47767 13.5729 9.47767 13.7955V17.0793H10.3242V13.7955C10.3242 13.3498 10.1435 12.9134 9.82815 12.5985L8.38307 11.1534ZM14.1854 8.76146L12.6599 7.21818C12.3213 6.83934 11.6576 6.8495 11.3363 7.20844L9.82857 8.78262L10.4398 9.36802L11.5776 8.1803V17.0793H12.4241V8.19807L13.5822 9.35659L14.1854 8.76146Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6844_3677"
          x1="12.0518"
          y1="2"
          x2="22.8269"
          y2="8.62105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B29BFF" />
          <stop offset="1" stop-color="#8064DE" />
        </linearGradient>
        <clipPath id="clip0_6844_3677">
          <rect
            width="10.1587"
            height="10.1587"
            fill="white"
            transform="translate(6.92053 6.92065)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
